// extracted by mini-css-extract-plugin
export default {"paypal_btn":"paypal_btn___JvmLm","hidden":"hidden___eJrvl"};